<template>
  <div
    class="bl_modalWindowComponent"
    v-bind:class="{ isActive: isActive }"
    v-on:click.self="close"
  >
    <div class="bl_modalWindowComponent_inner">
      <svg class="bl_modalWindowComponent_close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/></svg>
      <slot name="main_content" v-bind:close="close"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props:['initOnClickOpenClass'],
  data(){
    return{
      isActive:false,
      onClickOpenClass:this.initOnClickOpenClass,
    }
  },
  methods:{
    close(){
      this.isActive = false;
      document.querySelector('body').style.overflow = 'unset'
    },
    open(){
      this.isActive = true;
      document.querySelector('body').style.overflow = 'hidden'
    }
  },
  mounted(){
    let onClickOpenElements = document.querySelectorAll(`.${this.onClickOpenClass}`);
    onClickOpenElements.forEach(element => {
      element.addEventListener('click', () => {
        this.open()
      })
    });
  }
}
</script>
<style lang="scss">
.bl_modalWindowComponent{
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 100%;
  display: block;
  background-color: rgba($color: #000000, $alpha: 0.3);
  opacity: 0;
  z-index: -100;
  pointer-events: none;
  &_inner{
    position: relative;
  }
  &_close{
    position: absolute;
    top: -15px;
    right: -15px;
    transform: translate3d(-100%, -100%, 0);
    width: 30px;
    height: 30px;
    fill: #0a409a;
    pointer-events: none;
  }
  &.isActive{

    opacity: 1;
    z-index: 1000;
    pointer-events: auto;
  }
  @media screen and (min-width:768px) {
    display: grid;
    align-items: center;
    justify-content: center;
  }
}
</style>
